import React, { useEffect, useState } from 'react';
import { useToasts } from 'react-toast-notifications';
import { Row, Col, Button, Input, Card, CardBody, FormGroup, Table, 
    Modal, ModalHeader, ModalBody, ModalFooter, Form, Label, CardFooter} from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTranslation} from 'react-multi-lang';
//import { , Tr, Td, Thead, Tbody, Th } from 'react-super-responsive-table';
import {
    faPen,
    faPlus,
    faRefresh,
    faTimes
} from "@fortawesome/free-solid-svg-icons";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { VehiclesService } from '../Services/VehiclesService';


const Vehicles = ({t}) => {
    const [vehicles, setVehicles] = useState([]);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [total, setTotal] = useState(0);
    const [vehicle, setVehicle] = useState({});
    const [vehicleModalOpen, setVehicleModalOpen] = useState(false);

    const toggleVehicleModal = () => setVehicleModalOpen(!vehicleModalOpen);

    const vehiclesService = new VehiclesService();

    const { addToast } = useToasts();

    useEffect(() => {
        getVehicles();
    }, []);

    const getVehicles = () => {
        vehiclesService.getVehicles(search, page, perPage).then(r => {
            setVehicles(r[0]);
            setTotal(r[1]);
        }).catch(e => addToast(t('stock.errorGettingVehicles'), {appearance: 'error', autoDismiss: true, autoDismissTimeout: 5000}));
    };

    useEffect(() => {
        setPage(1);
        getVehicles();
    }, [search]);

    useEffect(() => {
        getVehicles();
    }, [page]);

    useEffect(() => {
        setPage(1);
        getVehicles();
    }, [perPage]);

    const saveVehicle = (e) => {
        e.preventDefault();
        if(!vehicle.plates){
            addToast("Πρέπει να καταχωρίσετε την πινακίδα του οχήματος", {appearance: 'error', autoDismiss: true, autoDismissTimeout: 5000});
            return false;
        }
        if(!vehicle.title){
            addToast("Πρέπει να καταχωρίσετε περιγραφή", {appearance: 'error', autoDismiss: true, autoDismissTimeout: 5000});
            return false;
        }
        if(!vehicle.weight){
            addToast("Πρέπει να καταχωρίσετε το βάρος του οχήματος", {appearance: 'error', autoDismiss: true, autoDismissTimeout: 5000});
            return false;
        }
        vehiclesService.saveVehicle(vehicle).then(r => {
            addToast('Το όχημα προστέθηκε με επιτυχία', {appearance: 'success', autoDismiss: true, autoDismissTimeout: 5000});
            toggleVehicleModal();
            getVehicles();
        }).catch(e => {
            addToast('Απέτυχε η καταχώριση του οχήματος', {appearance: 'error', autoDismiss: true, autoDismissTimeout: 5000});
        });
    };

    const deleteVehicle = (id) => {
        if(window.confirm("Θέλετε σίγουρα να διαγράψετε το όχημα;")){
            vehiclesService.deleteVehicle(id).then(r => {
                addToast('Το όχημα διεγράφη', {appearance: 'success', autoDismiss: true, autoDismissTimeout: 5000});
                getVehicles();
            }).catch(e => {
                addToast('Η διαγραφή απέτυχε', { appearance: 'error', autoDismiss: true, autoDismissTimeout: 5000 });
            })
        }
    }

    const openVehicle = (v) => {
        setVehicle(v);
        toggleVehicleModal();
    }

    const getPages = () => {
        let pages = [];
        let i = 1;
        while(i <= Math.ceil(total / perPage)){
            pages.push(i);
            i++;
        }
        return pages;
    }

    return  <Card style={{padding: '20px'}}>
            <CardBody>
                <h3>{t('sideBar.vehiclesManagement')}</h3>
                <Row>
                    <Col md="5">
                        <FormGroup>
                            <Input type="search" onChange={e => setSearch(e.target.value)} placeholder="Search"/>
                        </FormGroup>
                    </Col>
                    <Col md="1" className="d-grid">
                        <Button color="primary" size="sm" onClick={getVehicles}><FontAwesomeIcon icon={faRefresh} /></Button>
                    </Col>
                    <Col md="3" className="d-grid">
                        <ReactHTMLTableToExcel
                            id="unassessedButton"
                            className="btn btn-sm btn-success btn-block"
                            table="vehiclesTable"
                            filename="vehicles"
                            sheet="vehicles"
                            buttonText="Excel"/>
                    </Col>
                    <Col md="2" className="d-grid">
                        <Input type="select" defaultValue={perPage.toString()} onChange={e => setPerPage(e.target.value)}>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </Input>
                    </Col>
                    <Col md="1" className="d-grid">
                        <Button color="success" size="sm" onClick={toggleVehicleModal}><FontAwesomeIcon icon={faPlus} /></Button>
                    </Col>
                </Row>
                
                <Table responsive id="vehiclesTable">
                    <thead>
                        <tr>
                            <th>Πινακίδα Οχήματος</th>
                            <th>2η Πινακίδα Οχήματος (για ρυμουλκούμενο)</th>
                            <th>Περιγραφή</th>
                            <th>Απόβαρο</th>
                            <th>Μέγιστο καθαρό βάρος</th>
                            <th>Ενέργειες</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        vehicles && vehicles.sort((v1, v2) => v1.plate >= v2.plate ? 1 : -1).map(v => {
                            return <tr key={v.id} style={{borderBottom: '1px solid #aaa'}}>
                                <td >{v.plates}</td>
                                <td >{v.secondPlate}</td>
                                <td >{v.title}</td>
                                <td >{v.weight}</td>
                                <td >{v.maxWeight}</td>
                                <td style={{textAlign: 'right'}}>
                                    <Button color="primary" size="sm" onClick={() => openVehicle(v)}><FontAwesomeIcon icon={faPen} /></Button>{" "}
                                    <Button color="danger" size="sm" onClick={() => deleteVehicle(v.id)}><FontAwesomeIcon icon={faTimes} /></Button>
                                </td>
                            </tr>
                        })
                    }
                    </tbody>
                </Table>
        </CardBody>
        <CardFooter>
            {
                getPages().map(p => {
                    if(p > page-5 && p < page + 5){
                        return <Button key={p} color={p === page ? "primary" : "secondary"} size="sm" onClick={() => setPage(p)}>{p}</Button>
                    }
                })
            }
        </CardFooter>
        <Modal toggle={toggleVehicleModal} isOpen={vehicleModalOpen}>
            <ModalHeader>
                <h4>Όχημα {vehicle.title}</h4>
            </ModalHeader>
            <ModalBody>
                <Form onSubmit={saveVehicle}>
                    <FormGroup>
                        <Label>Πινακίδα</Label>
                        <Input type="text" defaultValue={vehicle.plates} onChange={(e) => setVehicle({...vehicle, plates: e.target.value})} />
                    </FormGroup>
                    <FormGroup>
                        <Label>2η Πινακίδα (Ρυμουλκούμενου)</Label>
                        <Input type="text" defaultValue={vehicle.secondPlate} onChange={(e) => setVehicle({...vehicle, secondPlate: e.target.value})} />
                    </FormGroup>
                    <FormGroup>
                        <Label>Περιγραφή</Label>
                        <Input type="text" defaultValue={vehicle.title} onChange={(e) => setVehicle({...vehicle, title: e.target.value})} />
                    </FormGroup>
                    <FormGroup>
                        <Label>Απόβαρο</Label>
                        <Input type="number" defaultValue={vehicle.weight} onChange={(e) => setVehicle({...vehicle, weight: e.target.valueAsNumber})} />
                    </FormGroup>
                    <FormGroup>
                        <Label>Μέγιστο Βάρος</Label>
                        <Input type="number" defaultValue={vehicle.maxWeight} onChange={(e) => setVehicle({...vehicle, maxWeight: e.target.valueAsNumber})} />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" size="sm" onClick={saveVehicle}>Αποθήκευση</Button>
            </ModalFooter>
        </Modal>
    </Card>
};

export default withTranslation(Vehicles);